import React from 'react';
import styles from './styles.scss';

function StartupCard({
  children,
  image,
  title,
  subtitle
}) {
  return (
    <div className={styles.cardSelector}>
      <div className={`${styles.front} text-center`}>
        <div className={styles.cardImage}>
          <img src={image} alt="startup includes" />
        </div>
        <p className="demi-bold">
          {title}
        </p>
        <p className="light-italics">
          {subtitle}
        </p>
      </div>
      <div className={styles.back}>
        <p className="text-center bold">
          {title}
        </p>
        <div className="mt20">
          {children}
        </div>
      </div>
    </div>
  );
}

export default StartupCard;



// WEBPACK FOOTER //
// ./src/components/StartupCard/index.js